import * as analyticsConstants from '../constants/analyticsConstants';
import * as dataTypeConstants from '../constants/dataTypeConstants';
import { priceBandConstants } from '../constants/priceBandConstants';

import type {
  CheckedState,
  Direction,
  HotelPriceDirection,
  PriceColour,
  Source,
  ViewMode,
} from '../logging/types';

const directionHelper = (
  direction: Direction | string,
):
  | typeof analyticsConstants.DEPART
  | typeof analyticsConstants.RETURN
  | typeof analyticsConstants.UNKNOWN => {
  if (direction === dataTypeConstants.OUTBOUND_DIRECTION)
    return analyticsConstants.DEPART;
  if (direction === dataTypeConstants.INBOUND_DIRECTION)
    return analyticsConstants.RETURN;
  return analyticsConstants.UNKNOWN;
};

const minieventDirectionHelper = (
  direction: Direction | string,
):
  | typeof analyticsConstants.DEPART_MINIEVENT
  | typeof analyticsConstants.RETURN_MINIEVENT
  | typeof analyticsConstants.UNKNOWN_DIRECTION_MINIEVENT => {
  if (direction === dataTypeConstants.OUTBOUND_DIRECTION)
    return analyticsConstants.DEPART_MINIEVENT;
  if (direction === dataTypeConstants.INBOUND_DIRECTION)
    return analyticsConstants.RETURN_MINIEVENT;
  return analyticsConstants.UNKNOWN_DIRECTION_MINIEVENT;
};

const directionSelectHelper = (
  direction: Direction | string,
):
  | typeof analyticsConstants.DEPARTUREDATESELECT
  | typeof analyticsConstants.RETURNDATESELECT
  | typeof analyticsConstants.UNKOWNDATESELECT => {
  if (direction === dataTypeConstants.OUTBOUND_DIRECTION) {
    return analyticsConstants.DEPARTUREDATESELECT;
  }
  if (direction === dataTypeConstants.INBOUND_DIRECTION) {
    return analyticsConstants.RETURNDATESELECT;
  }
  return analyticsConstants.UNKOWNDATESELECT;
};

const isCheckedHelper = (
  checked: CheckedState,
): typeof analyticsConstants.CHECKED | typeof analyticsConstants.UNCHECKED => {
  if (checked) {
    return analyticsConstants.CHECKED;
  }
  return analyticsConstants.UNCHECKED;
};

const sourceHelper = (
  source: Source,
):
  | typeof analyticsConstants.MONTH_PREVIOUS
  | typeof analyticsConstants.MONTH_SELECT
  | typeof analyticsConstants.MONTH_NEXT
  | typeof analyticsConstants.UNKNOWN => {
  if (source === dataTypeConstants.PREVIOUS_SOURCE)
    return analyticsConstants.MONTH_PREVIOUS;
  if (source === dataTypeConstants.SELECT_SOURCE)
    return analyticsConstants.MONTH_SELECT;
  if (source === dataTypeConstants.NEXT_SOURCE)
    return analyticsConstants.MONTH_NEXT;
  return analyticsConstants.UNKNOWN;
};

const viewModeHelper = (
  mode: ViewMode,
):
  typeof analyticsConstants.CHART | typeof analyticsConstants.CALENDAR | '' => {
  if (mode === dataTypeConstants.BAR_CHART_VIEW_MODE)
    return analyticsConstants.CHART;
  if (mode === dataTypeConstants.CALENDAR_VIEW_MODE)
    return analyticsConstants.CALENDAR;
  return '';
};

const minieventViewModeHelper = (
  mode: ViewMode,
):
  | typeof analyticsConstants.CHART_MINIEVENT
  | typeof analyticsConstants.CALENDAR_MINIEVENT
  | typeof analyticsConstants.UNKNOWN_MODE_MINIEVENT => {
  if (mode === dataTypeConstants.BAR_CHART_VIEW_MODE)
    return analyticsConstants.CHART_MINIEVENT;
  if (mode === dataTypeConstants.CALENDAR_VIEW_MODE)
    return analyticsConstants.CALENDAR_MINIEVENT;
  return analyticsConstants.UNKNOWN_MODE_MINIEVENT;
};

const minieventPriceCategoryHelper = (
  cssColour: PriceColour,
):
  | typeof analyticsConstants.PRICE_CATEGORY_LOW
  | typeof analyticsConstants.PRICE_CATEGORY_MEDIUM
  | typeof analyticsConstants.PRICE_CATEGORY_HIGH
  | typeof analyticsConstants.PRICE_CATEGORY_NO_PRICE
  | typeof analyticsConstants.PRICE_CATEGORY_UNSET => {
  if (cssColour === priceBandConstants.LOW_PRICE_CLASS)
    return analyticsConstants.PRICE_CATEGORY_LOW;
  if (cssColour === priceBandConstants.MEDIUM_PRICE_CLASS)
    return analyticsConstants.PRICE_CATEGORY_MEDIUM;
  if (cssColour === priceBandConstants.HIGH_PRICE_CLASS)
    return analyticsConstants.PRICE_CATEGORY_HIGH;
  if (cssColour === priceBandConstants.DEFAULT_PRICE_CLASS)
    return analyticsConstants.PRICE_CATEGORY_NO_PRICE;
  return analyticsConstants.PRICE_CATEGORY_UNSET;
};

const minieventHotelPriceCategoryHelper = (
  priceDirection: HotelPriceDirection,
):
  | typeof analyticsConstants.PRICE_CATEGORY_LOW
  | typeof analyticsConstants.PRICE_CATEGORY_MEDIUM
  | typeof analyticsConstants.PRICE_CATEGORY_HIGH
  | typeof analyticsConstants.PRICE_CATEGORY_NO_PRICE
  | typeof analyticsConstants.PRICE_CATEGORY_UNSET => {
  if (priceDirection === priceBandConstants.HOTEL_PRICE_DIRECTION_CHEAP)
    return analyticsConstants.PRICE_CATEGORY_LOW;
  if (priceDirection === priceBandConstants.HOTEL_PRICE_DIRECTION_MODERATE)
    return analyticsConstants.PRICE_CATEGORY_MEDIUM;
  if (priceDirection === priceBandConstants.HOTEL_PRICE_DIRECTION_EXPENSIVE)
    return analyticsConstants.PRICE_CATEGORY_HIGH;
  if (priceDirection === null)
    return analyticsConstants.PRICE_CATEGORY_NO_PRICE;
  return analyticsConstants.PRICE_CATEGORY_UNSET;
};

export {
  directionHelper,
  directionSelectHelper,
  minieventDirectionHelper,
  isCheckedHelper,
  sourceHelper,
  viewModeHelper,
  minieventViewModeHelper,
  minieventPriceCategoryHelper,
  minieventHotelPriceCategoryHelper,
};
